import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="64"
    height="74"
    viewBox="0 0 64 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17.5528" cy="21.3643" r="10.9028" fill="#CE8C0C" />
    <circle
      cx="17.5528"
      cy="20.1528"
      r="10.9028"
      fill="url(#paint0_linear_1982_12)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5529 28.0269C21.9017 28.0269 25.4271 24.5014 25.4271 20.1526C25.4271 15.8038 21.9017 12.2784 17.5529 12.2784C13.2041 12.2784 9.6787 15.8038 9.6787 20.1526C9.6787 24.5014 13.2041 28.0269 17.5529 28.0269ZM17.5529 29.2383C22.5708 29.2383 26.6385 25.1705 26.6385 20.1526C26.6385 15.1348 22.5708 11.067 17.5529 11.067C12.5351 11.067 8.46729 15.1348 8.46729 20.1526C8.46729 25.1705 12.5351 29.2383 17.5529 29.2383Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.4268 20.1526C25.4268 14.7013 20.8341 12.6209 19.6726 11.9756C18.5111 11.3303 17.5526 11.067 17.5526 11.067C22.5705 11.067 26.6382 15.1348 26.6382 20.1526C26.6382 25.1705 22.5705 29.2383 17.5526 29.2383C17.5526 29.2383 17.8558 29.2333 19.6726 28.6326C21.4894 28.0318 25.4268 24.5014 25.4268 20.1526Z"
      fill="#D89C00"
    />
    <path
      d="M17.1305 24.3928C16.0496 24.3928 15.0091 24.0966 14.0898 23.4518C13.4491 23.0026 12.7075 21.9881 12.7075 20.2683C12.7075 17.0777 14.3159 15.9133 17.5482 15.9133L22.1925 15.9133C22.1925 15.9133 22.3356 15.9058 22.3762 15.9541C22.4272 16.0148 22.3762 16.1584 22.3762 16.1584L21.9391 17.5168C21.9391 17.5168 21.8812 17.6431 21.8212 17.6843C21.7509 17.7325 21.6366 17.7305 21.6366 17.7305H17.9916C15.8583 17.7305 14.5898 17.8991 14.5898 20.2683C14.5898 21.0509 14.8076 21.6078 15.2558 21.9707C16.0134 22.5841 17.486 22.6102 18.3858 22.5223C18.3858 22.5223 18.7549 21.3194 18.8157 21.1241C18.8869 20.8953 18.8558 20.8407 18.6336 20.8407C18.3127 20.8407 17.7358 20.8407 17.1236 20.8407C16.6945 20.8407 16.2729 20.6219 16.2729 20.0963C16.2729 19.5887 16.6651 19.2941 17.2028 19.2941C18.1336 19.2941 20.0509 19.2941 20.4097 19.2941C20.8801 19.2941 21.3602 19.3624 21.1152 20.1171L19.8181 24.1033C19.8181 24.1033 18.7584 24.3928 17.1305 24.3928Z"
      fill="#E2A60B"
    />
    <circle cx="17.1028" cy="51.3587" r="10.9028" fill="#CE8C0C" />
    <circle
      cx="17.1028"
      cy="50.1473"
      r="10.9028"
      fill="url(#paint1_linear_1982_12)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.103 58.0214C21.4518 58.0214 24.9772 54.496 24.9772 50.1471C24.9772 45.7983 21.4518 42.2729 17.103 42.2729C12.7542 42.2729 9.22875 45.7983 9.22875 50.1471C9.22875 54.496 12.7542 58.0214 17.103 58.0214ZM17.103 59.2328C22.1208 59.2328 26.1886 55.165 26.1886 50.1471C26.1886 45.1293 22.1208 41.0615 17.103 41.0615C12.0851 41.0615 8.01733 45.1293 8.01733 50.1471C8.01733 55.165 12.0851 59.2328 17.103 59.2328Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.9769 50.1471C24.9769 44.6958 20.3841 42.6154 19.2226 41.9701C18.0611 41.3248 17.1027 41.0615 17.1027 41.0615C22.1205 41.0615 26.1883 45.1293 26.1883 50.1471C26.1883 55.165 22.1205 59.2328 17.1027 59.2328C17.1027 59.2328 17.4058 59.2278 19.2226 58.6271C21.0395 58.0263 24.9769 54.496 24.9769 50.1471Z"
      fill="#D89C00"
    />
    <path
      d="M16.6804 54.3873C15.5995 54.3873 14.559 54.0912 13.6398 53.4464C12.999 52.9971 12.2574 51.9827 12.2574 50.2629C12.2574 47.0723 13.8659 45.9078 17.0981 45.9078L21.7425 45.9078C21.7425 45.9078 21.8855 45.9004 21.9261 45.9486C21.9771 46.0094 21.9261 46.153 21.9261 46.153L21.489 47.5114C21.489 47.5114 21.4312 47.6377 21.3711 47.6789C21.3008 47.7271 21.1865 47.7251 21.1865 47.7251H17.5416C15.4082 47.7251 14.1397 47.8937 14.1397 50.2629C14.1397 51.0455 14.3575 51.6024 14.8058 51.9653C15.5634 52.5787 17.0359 52.6048 17.9357 52.5169C17.9357 52.5169 18.3049 51.314 18.3657 51.1187C18.4369 50.8899 18.4057 50.8353 18.1835 50.8353C17.8626 50.8353 17.2858 50.8353 16.6735 50.8353C16.2444 50.8353 15.8229 50.6164 15.8229 50.0909C15.8229 49.5833 16.2151 49.2887 16.7527 49.2887C17.6836 49.2887 19.6008 49.2887 19.9596 49.2887C20.43 49.2887 20.9101 49.357 20.6652 50.1116L19.368 54.0979C19.368 54.0979 18.3084 54.3873 16.6804 54.3873Z"
      fill="#E2A60B"
    />
    <circle cx="47.0973" cy="51.3587" r="10.9028" fill="#CE8C0C" />
    <circle
      cx="47.0973"
      cy="50.1473"
      r="10.9028"
      fill="url(#paint2_linear_1982_12)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.0975 58.0214C51.4463 58.0214 54.9717 54.496 54.9717 50.1471C54.9717 45.7983 51.4463 42.2729 47.0975 42.2729C42.7487 42.2729 39.2233 45.7983 39.2233 50.1471C39.2233 54.496 42.7487 58.0214 47.0975 58.0214ZM47.0975 59.2328C52.1153 59.2328 56.1831 55.165 56.1831 50.1471C56.1831 45.1293 52.1153 41.0615 47.0975 41.0615C42.0796 41.0615 38.0118 45.1293 38.0118 50.1471C38.0118 55.165 42.0796 59.2328 47.0975 59.2328Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.9714 50.1471C54.9714 44.6958 50.3786 42.6154 49.2171 41.9701C48.0557 41.3248 47.0972 41.0615 47.0972 41.0615C52.115 41.0615 56.1828 45.1293 56.1828 50.1471C56.1828 55.165 52.115 59.2328 47.0972 59.2328C47.0972 59.2328 47.4003 59.2278 49.2171 58.6271C51.034 58.0263 54.9714 54.496 54.9714 50.1471Z"
      fill="#D89C00"
    />
    <path
      d="M46.6749 54.3873C45.5941 54.3873 44.5535 54.0912 43.6343 53.4464C42.9935 52.9971 42.252 51.9827 42.252 50.2629C42.252 47.0723 43.8604 45.9078 47.0926 45.9078L51.737 45.9078C51.737 45.9078 51.88 45.9004 51.9206 45.9486C51.9717 46.0094 51.9206 46.153 51.9206 46.153L51.4835 47.5114C51.4835 47.5114 51.4257 47.6377 51.3656 47.6789C51.2953 47.7271 51.181 47.7251 51.181 47.7251H47.5361C45.4027 47.7251 44.1342 47.8937 44.1342 50.2629C44.1342 51.0455 44.352 51.6024 44.8003 51.9653C45.5579 52.5787 47.0304 52.6048 47.9302 52.5169C47.9302 52.5169 48.2994 51.314 48.3602 51.1187C48.4314 50.8899 48.4002 50.8353 48.178 50.8353C47.8571 50.8353 47.2803 50.8353 46.668 50.8353C46.2389 50.8353 45.8174 50.6164 45.8174 50.0909C45.8174 49.5833 46.2096 49.2887 46.7472 49.2887C47.6781 49.2887 49.5953 49.2887 49.9541 49.2887C50.4246 49.2887 50.9046 49.357 50.6597 50.1116L49.3625 54.0979C49.3625 54.0979 48.3029 54.3873 46.6749 54.3873Z"
      fill="#E2A60B"
    />
    <circle cx="46.0973" cy="21.1142" r="10.9028" fill="#CE8C0C" />
    <circle
      cx="46.0973"
      cy="19.9028"
      r="10.9028"
      fill="url(#paint3_linear_1982_12)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.0975 27.7769C50.4463 27.7769 53.9717 24.2514 53.9717 19.9026C53.9717 15.5538 50.4463 12.0284 46.0975 12.0284C41.7487 12.0284 38.2233 15.5538 38.2233 19.9026C38.2233 24.2514 41.7487 27.7769 46.0975 27.7769ZM46.0975 28.9883C51.1153 28.9883 55.1831 24.9205 55.1831 19.9026C55.1831 14.8848 51.1153 10.817 46.0975 10.817C41.0796 10.817 37.0118 14.8848 37.0118 19.9026C37.0118 24.9205 41.0796 28.9883 46.0975 28.9883Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.9714 19.9026C53.9714 14.4513 49.3786 12.3709 48.2171 11.7256C47.0557 11.0803 46.0972 10.817 46.0972 10.817C51.115 10.817 55.1828 14.8848 55.1828 19.9026C55.1828 24.9205 51.115 28.9883 46.0972 28.9883C46.0972 28.9883 46.4003 28.9833 48.2171 28.3826C50.034 27.7818 53.9714 24.2514 53.9714 19.9026Z"
      fill="#D89C00"
    />
    <path
      d="M45.6749 24.1429C44.5941 24.1429 43.5535 23.8467 42.6343 23.2019C41.9935 22.7527 41.252 21.7382 41.252 20.0184C41.252 16.8278 42.8604 15.6634 46.0926 15.6634L50.737 15.6634C50.737 15.6634 50.88 15.656 50.9206 15.7042C50.9717 15.7649 50.9206 15.9085 50.9206 15.9085L50.4835 17.2669C50.4835 17.2669 50.4257 17.3932 50.3656 17.4344C50.2953 17.4826 50.181 17.4806 50.181 17.4806H46.5361C44.4027 17.4806 43.1342 17.6492 43.1342 20.0184C43.1342 20.801 43.352 21.358 43.8003 21.7208C44.5579 22.3342 46.0304 22.3603 46.9302 22.2724C46.9302 22.2724 47.2994 21.0695 47.3602 20.8743C47.4314 20.6454 47.4002 20.5908 47.178 20.5908C46.8571 20.5908 46.2803 20.5908 45.668 20.5908C45.2389 20.5908 44.8174 20.372 44.8174 19.8464C44.8174 19.3388 45.2096 19.0442 45.7472 19.0442C46.6781 19.0442 48.5953 19.0442 48.9541 19.0442C49.4246 19.0442 49.9046 19.1126 49.6597 19.8672L48.3625 23.8534C48.3625 23.8534 47.3029 24.1429 45.6749 24.1429Z"
      fill="#E2A60B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1982_12"
        x1="17.5528"
        y1="9.25"
        x2="17.5528"
        y2="31.0555"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1982_12"
        x1="17.1028"
        y1="39.2445"
        x2="17.1028"
        y2="61.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1982_12"
        x1="47.0973"
        y1="39.2445"
        x2="47.0973"
        y2="61.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1982_12"
        x1="46.0973"
        y1="9"
        x2="46.0973"
        y2="30.8055"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
    </defs>
  </SvgIcon>
));
